export default __webpack_public_path__ + "static/media/26.7308c6b2.jpg";